import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Lock } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import Button from '../../components/common/Button';

export default function Login() {
  const navigate = useNavigate();
  const { initiateGoogleLogin } = useAuth();

  const handleSignup = () => {
    navigate('/signup');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-old-lace to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between py-12 gap-12">
          {/* Left side - Brand messaging */}
          <div className="flex-1 max-w-xl">
            <div className="mb-8">
              <img 
                src="/violetMidnightStickrLogo.svg" 
                alt="Logo" 
                className="h-10" 
              />
            </div>
              
            <h1 className="text-4xl font-bold text-midnight font-heading mb-4">
              Secure Communications Made Simple
            </h1>
            <p className="text-lg text-ebony mb-8">
              Protect your email communications with enterprise-grade security and seamless verification.
            </p>

            <div className="grid gap-6">
              {features.map((feature) => (
                <div key={feature.title} className="flex items-start gap-4">
                  <div className="p-2 rounded-xl bg-violet/10">
                    <feature.icon className="h-6 w-6 text-violet" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-midnight font-heading">{feature.title}</h3>
                    <p className="text-sm text-ebony">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right side - Login form */}
          <div className="w-full max-w-md">
            <div className="bg-white rounded-xl shadow-md p-8">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-bold text-midnight font-heading mb-2">Welcome Back</h2>
                <p className="text-ebony">Sign in to access your secure email dashboard</p>
              </div>

              <Button
                onClick={initiateGoogleLogin}
                className="w-full flex items-center justify-center gap-2 bg-white border-2 border-light-purple text-midnight hover:bg-light-purple/10 mb-4 rounded-pill"
              >
                <img 
                  src="https://www.google.com/favicon.ico" 
                  alt="Google" 
                  className="w-5 h-5"
                />
                Continue with Google
              </Button>

              <div className="text-center">
                <p className="text-sm text-ebony">
                  Don't have an account?{' '}
                  <Button
                    variant="link"
                    onClick={handleSignup}
                    className="font-medium text-violet"
                  >
                    Sign up now
                  </Button>
                </p>
              </div>
            </div>

            <div className="mt-6 text-center">
              <div className="flex items-center justify-center gap-2 text-sm text-ebony">
                <Lock className="w-4 h-4 text-ebony" />
                Enterprise-grade security
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const features = [
  {
    icon: Shield,
    title: 'Verified Sender Identity',
    description: 'Know exactly who sent each email with our advanced verification system'
  },
  {
    icon: Lock,
    title: 'Complete Email Protection',
    description: 'Enterprise-grade security for all your email communications'
  }
];